module.exports = __webpack_public_path__ + "static/media/service-left.871dc864.svg";